import {
  Box,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  OutlinedInput as MuiOutlinedInput,
  withStyles,
  styled,
} from '@material-ui/core'
import PageTitle from 'components/PageTitle'
import { range } from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  formControl: {
    'height': 60,
    'width': 260,
    'marginLeft': theme.spacing(1),
    '& .MuiFormLabel-root': {
      color: theme.palette.white.main,
      fontSize: theme.typography.pxToRem(14),
    },
    '& .MuiInputBase-root:hover': {
      color: theme.palette.white.main,
    },
  },
  select: {
    'color': theme.palette.white.main,
    '& .MuiSelect-root': {
      borderColor: theme.palette.white.main,
    },
  },
  iconSelect: {
    color: theme.palette.white.main,
  },
}))

const OutlinedInput = withStyles(theme => ({
  root: {
    '& $notchedOutline': {
      borderColor: theme.palette.white.main,
    },
    '&:hover $notchedOutline': {
      borderColor: theme.palette.white.main,
    },
    '&$focused $notchedOutline': {
      borderColor: theme.palette.white.main,
    },
  },
  focused: {},
  notchedOutline: {},
}))(MuiOutlinedInput)

const HeaderContainer = styled('span')(({ theme }) => ({
  height: 183,
}))

const anoAtual = +moment().format('YYYY')
const anos = range(2014, anoAtual + 2).map(ano => ({
  value: ano,
  label: `${ano - 1}/${ano.toString().slice(2, 4)}`,
}))

export const PageHeader = ({ onChangeAno }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const [anoSelecionado, setAnoSelecionado] = useState(anoAtual.toString())

  const handleChangeAno = event => {
    setAnoSelecionado(event.target.value)
    onChangeAno?.(event.target.value)
  }

  useEffect(() => {
    onChangeAno?.(anoAtual)
  }, [onChangeAno])

  return (
    <HeaderContainer>
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        <Box justifyContent='flex-start' flex={1}>
          <PageTitle title={t('creditosDeBiodiversidade.titulo')} />
        </Box>
        <Box>
          <FormControl variant='outlined' className={classes.formControl}>
            <InputLabel htmlFor='ano-base'>{t('pressaoBiodiversidade.selecioneAno')}</InputLabel>
            <Select
              classes={{
                select: classes.select,
                icon: classes.iconSelect,
              }}
              value={anoSelecionado}
              onChange={handleChangeAno}
              label={t('pressaoBiodiversidade.selecioneAno')}
              inputProps={{
                name: 'ano-base',
                id: 'ano-base',
              }}
              input={<OutlinedInput label={t('pressaoBiodiversidade.selecioneAno')} />}>
              {anos.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </HeaderContainer>
  )
}
